module.exports = __webpack_public_path__ + "assets/img/video-toBtn.9ded5110.png";